const DownloadStatus = {
    "False": 0,
    "True": 1,
    "Cancelled": 2,
    "AlreadyCompleted": 3
};

export default DownloadStatus;